/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QueryRowsResponseDto } from './query-rows-response-dto';
import { ResultMetadataSchema } from './result-metadata-schema';
import { ResultFreshness } from './result-freshness';


export interface QueryResultsResponseDto { 
    /**
     * True when the rows came from the query-result cache instead of a warehouse run.
     */
    cacheHit?: boolean;
    /**
     * Warehouse run time in milliseconds once the query finished. Absent on a cache hit.
     */
    durationMs?: number;
    /**
     * Milliseconds since the warehouse run started, while it is still running.
     */
    elapsedMs?: number;
    /**
     * True when the run took 5 s or more: tell the user how long it takes and what that means on a dashboard, and try a narrower period while revising it. Absent on a cache hit.
     */
    slow?: boolean;
    /**
     * QUERY_TIMEOUT when the warehouse stopped the query at the statement cap (60 s for dashboard tiles, 180 s for agent queries); narrow the date range or group by fewer values. QUERY_CANCELLED, with status cancelled, when the warehouse cancelled the query on request; run it again.
     */
    errorCode?: QueryResultsResponseDto.ErrorCodeEnum;
    /**
     * fresh: computed inside the cache window. stale: an older result served at once while one background refresh runs; show computedAt. computing: the query is still queued or running.
     */
    freshness?: ResultFreshness;
    /**
     * When the rows were computed, for an \"as of\" label.
     */
    computedAt?: string;
    /**
     * Current execution status.
     */
    status: QueryResultsResponseDto.StatusEnum;
    /**
     * Rows returned by the query once execution succeeds.
     */
    result?: QueryRowsResponseDto;
    /**
     * Column names and the true row count of the full executed result set (independent of any sampling).
     */
    resultMetadata?: ResultMetadataSchema;
    /**
     * True when `result.rows` is a truncated sample of `resultMetadata.rowCount` (the caller passed `sampleRows`). A large `rowCount` with `sampled: true` is the signal to visualize the data as a chart rather than read the rows.
     */
    sampled?: boolean;
    /**
     * Execution error message when status is error.
     */
    error?: string;
}
export namespace QueryResultsResponseDto {
    export const ErrorCodeEnum = {
        QueryTimeout: 'QUERY_TIMEOUT',
        QueryCancelled: 'QUERY_CANCELLED'
    } as const;
    export type ErrorCodeEnum = typeof ErrorCodeEnum[keyof typeof ErrorCodeEnum];
    export const StatusEnum = {
        Error: 'error',
        Pending: 'pending',
        Running: 'running',
        Success: 'success',
        Generating: 'generating',
        Cancelled: 'cancelled'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


